import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { PaymentProtectionBadge } from './PaymentProtectionBadge';

interface Params {
  node: HTMLElement;
}

export const PaymentProtectionBadgeInitializer = (params: Params): Initializer => ({
  destroy: () => ReactDOM.unmountComponentAtNode(params.node),
  render: () => {
    ReactDOM.render(<PaymentProtectionBadge />, params.node);
  },
});
